import React from "react"
import {Link} from "react-router-dom"

function About(props){

  const containerStyle={
    margin: '3vh auto',
    backgroundColor: '#012782',
    color:'white'
  }
  
  const colStyle = {
    border: 'medium solid darkBlue',
    
  }

  const headerStyle = {
    
  }



  return(
    <div className="container" style={containerStyle}>


      <div className="row">
        <div className="col-8 p-3">
          <h2>About The Lab</h2>
        </div>
      </div>


      <div className="row justify-content-center align-items-center">

        <div className="col-xs-10 col-sm-3 my-3">
          <div className="col-6">
            <img src={ require("../images/jwoh.jpg") } />
            <Link to="/professor"><button className="btn btn-primary btn-sm m-2">About me</button></Link>
          </div>
        </div>

        <div className="col-xs-10 col-sm-9 my-3">
          <h3>Welcome to the Molecular Virology Lab</h3>
          <h5>Greetings, Professor. Jong-Won Oh</h5>
          <p>Our lab focuses on two main areas: <br/>
          (A) Understanding the mechanism of replication of plus-strand RNA viruses including hepatitis C virus, SARS-Corona virus, Japanese Encephalitis virus and regulation of their propagation. <br/>
          (B) Study on the virus-host interactions to explore the roles of cellular proteins in virus life cycle and virus-induced pathogenesis.</p>
        </div>

      </div>


    </div>
  )
}



export default About